import type { IMakeRequired } from '~/helpers/types';
import type { IStorage, IStorageOptions } from './types';
import { defaultOptions } from './types';

export class InMemoryStorage implements IStorage {
  private options: IMakeRequired<IStorageOptions, 'prefix'>;
  private store: Record<string, unknown> = {};

  public constructor(options?: IStorageOptions) {
    this.options = { ...defaultOptions, ...options };
  }

  private uriFromKey(key: string): string {
    return `${this.options.prefix}::${key}`;
  }

  private keyFromUri(uri: string): string {
    return uri.substring(`${this.options.prefix}::`.length);
  }

  public set<T>(key: string, value: T): void {
    const uri = this.uriFromKey(key);
    if (value === undefined) {
      delete this.store[uri];

      return;
    }

    this.store[uri] = value;
  }

  public get<T>(key: string): T | undefined {
    const uri = this.uriFromKey(key);
    const cacheEntry = this.store[uri] as T;

    return cacheEntry;
  }

  public delete(key: string): void {
    const uri = this.uriFromKey(key);
    delete this.store[uri];
  }

  public allKeys(): Array<string> {
    return Object.keys(this.store).map((uri) => this.keyFromUri(uri));
  }
}
